<script>
  import { BigNumber } from "bignumber.js";
  import Constants from "../Constants";
  import { createEventDispatcher } from "svelte";
  import { Howl } from "howler";

  const MAX_DIGIT = 12;
  const MAX_NUMBER = 10 ** MAX_DIGIT - 1;
  const MIN_NUMBER = MAX_NUMBER * -1;

  BigNumber.config({
    DECIMAL_PLACES: 6,
  });

  const sound = new Howl({
    src: "/explosion3.mp3",
    html5: true,
  });
  const dispatch = createEventDispatcher();

  export let level;

  let terms = [];
  let operator = "";
  let viewings = "0";
  let isExplosion = false;

  let beforeInput = true;

  const buttons = [];
  Constants.BUTTONS.forEach((button) => {
    buttons.push({
      key: button.key,
      text: button.text,
      class: "",
      style: "",
    });
  });

  /**
   * 計算処理
   */
  const calculate = () => {
    const item = new BigNumber(terms[0]);
    let result = "";
    if (operator === "addition") {
      result = item.plus(terms[1]);
    } else if (operator === "subtraction") {
      result = item.minus(terms[1]);
    } else if (operator === "multiplication") {
      result = item.multipliedBy(terms[1]);
    } else if (operator === "division") {
      result = item.dividedBy(terms[1]);
    }
    if (hasErrorNumber(result)) {
      alert("電卓の手に余る値が出てきたのでリセットします。");
      reset();
      return;
    }
    viewings = result.toFixed();
    terms = [];
    operator = "";
    // 計算に成功したら1 ～ 現在レベル*3までの経験値をランダムで追加
    addExp(getRandomIntInclusive(1, level * 3));
  };

  /**
   * 数値にエラーがあったらtrue
   * @param number 数値
   */
  const hasErrorNumber = (number) => {
    if (number.isNaN()) {
      return true;
    }
    if (number.gt(MAX_NUMBER)) {
      return true;
    }
    if (number.lt(MIN_NUMBER)) {
      return true;
    }
    return false;
  };

  /**
   * 各種ボタン押下時の処理
   * @param key ボタンのキー情報
   */
  const clickCalcButton = (key) => {
    addExp(1);
    if (key === "C") {
      reset();
    } else if (key === "E") {
      isExplosion = true;
      sound.play();
      setTimeout(() => {
        isExplosion = false;
      }, 1000);
    } else if (key === "plusminus") {
      if (viewings.endsWith(".")) {
        // 入力中の数値の末尾が . だったら何もしない
        return;
      }
      viewings = new BigNumber(viewings).multipliedBy(-1).toFixed();
    } else if (key === "percent") {
      if (isNaN(viewings)) {
        return;
      }
      viewings = new BigNumber(viewings).dividedBy(100).toFixed();
      return;
    } else if (key === "equal") {
      if (operator === "" || terms.length < 1) {
        return;
      }
      // 合計
      terms.push(Number(viewings));
      calculate();
    } else if (isNumberKey(key)) {
      if (viewings.length === MAX_DIGIT) {
        return;
      }
      if (key === "dot" && viewings.indexOf(".") != -1) {
        return;
      }
      if (isOperatorText(viewings)) {
        viewings = "";
      }
      if (beforeInput) {
        if (key != "dot") {
          viewings = "";
        }
        beforeInput = false;
      } else {
        if (viewings === "0" && key !== "dot") {
          viewings = "";
        }
      }
      viewings += key === "dot" ? "." : key;
    } else if (isOperatorKey(key)) {
      if (viewings.endsWith(".")) {
        // 入力中の数値の末尾が . だったら何もしない
        return;
      }
      if (beforeInput) {
        return;
      }
      if (!isNaN(viewings)) {
        terms = [Number(viewings)];
      }
      operator = key;
      viewings = getButtonFromKey(key).text;
    }
  };

  /**
   * 指定したキー名が数字かどうかを判定
   * @param key キー
   * @returns 数字ならtrue
   */
  const isNumberKey = (key) => {
    if (key === "dot") {
      return true;
    }
    return !isNaN(key);
  };

  /**
   * 指定したキー名が演算子かどうかを判定
   * @param key キー
   * @returns 演算子ならtrue
   */
  const isOperatorKey = (key) => {
    if (
      key === "division" ||
      key === "multiplication" ||
      key === "subtraction" ||
      key === "addition"
    ) {
      return true;
    }
    return false;
  };
  /**
   * 指定したキーテキストが演算子かどうかを判定
   * @param key キーテキスト
   * @returns 演算子ならtrue
   */
  const isOperatorText = (key) => {
    if (key === "÷" || key === "×" || key === "－" || key === "＋") {
      return true;
    }
    return false;
  };

  /**
   * キー名からボタン設定を取得
   * @param key キー名
   * @returns ボタン設定
   */
  const getButtonFromKey = (key) => {
    return Constants.BUTTONS.find((button) => button.key === key);
  };

  /**
   * 計算処理リセット
   */
  const reset = () => {
    viewings = "0";
    beforeInput = true;
    terms = [];
    operator = "";
  };

  /**
   * レベルアップ時のボタン表示更新処理
   * @param level 現在のレベル
   */
  export const updateLevel = (level) => {
    buttons.forEach((button) => {
      const setting = Constants.BUTTON_SETTINGS[level - 1].find(
        (setting) => setting.key === button.key
      );
      if (!setting) {
        button.class = "hidden";
        return;
      } else {
        button.class = "";
      }
      const rowStyle = `grid-row: ${setting.row};`;
      const colStyle = `grid-column: ${setting.col};`;
      button.style = `${rowStyle}${colStyle}`;
    });
    buttons = buttons;
  };

  /**
   * 経験値加算
   * @param exp 経験値
   */
  const addExp = (exp) => {
    //親コンポーネントの経験値加算処理を呼び出し
    dispatch("addExp", {
      exp: exp,
    });
  };
  /**
   * min以上max以下の整数をランダムで返す
   * @param min 最小値
   * @param max 最大値
   * @returns min以上max以下の乱数
   */
  const getRandomIntInclusive = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
  };

  const formatNumber = (number) => {
    const value = new BigNumber(number);
    if (value.isNaN()) {
      return number;
    }
    return value.toFormat();
  };
</script>

<div class="calculator-container">
  <div class="result-container">{formatNumber(viewings)}</div>
  <div class="button-container">
    {#each buttons as button}
      <div class={button.class} style={button.style}>
        <button
          on:click={() => {
            clickCalcButton(button.key);
          }}
        >
          {button.text}
        </button>
      </div>
    {/each}
  </div>
</div>
{#if isExplosion}
  <img class="explosion" src={"/explosion.jpg"} alt="explosion" />
{/if}

<style lang="scss">
  .calculator-container {
    width: 90%;
    max-width: 480px;
    display: flex;
    flex-direction: column;
    background-color: rgb(22, 61, 112);
    padding: 20px;
    border-radius: 15px;
  }
  .result-container {
    background-color: darkgray;
    color: white;
    text-align: right;
    padding: 7px 15px;
    border-radius: 5px;
    font-size: 1.8rem;
    line-height: 100%;
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.5) inset;
  }
  .button-container {
    margin-top: 10px;
    aspect-ratio: 4 / 5;
    width: 100%;
    background-color: rgba(165, 165, 165, 0.281);
    display: grid;
    grid-template-rows: 20% 20% 20% 20% 20%;
    grid-template-columns: 25% 25% 25% 25%;
    border-radius: 10px;
    padding: 5px;
    > div {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    button {
      width: 90%;
      height: 90%;
      border-radius: 10px;
      border: none;
      font-size: 1.8rem;
      margin: 0;
      background-color: rgb(236, 236, 236);
      font-weight: bold;
      color: rgb(48, 48, 48);
      box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.5);
      &:active {
        position: relative;
        top: 3px;
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.5);
      }
    }
  }

  .explosion {
    position: absolute;
    top: auto;
    left: auto;
    z-index: 2;
    width: 100%;
    max-width: 600px;
  }
</style>
